import { ApolloError } from '@apollo/client';
import { createContext, useContext } from 'react';
import useGetProfileCompletionUserData from '@src/hooks/useGetProfileCompletionUserData';

export interface ProfileCompletionDataInterface {
  profile_complete_at?: string | null;
  prior_education_experience?: string;
}

interface ProfileCompletionContextInterface {
  error?: ApolloError;
  loading?: boolean;
  isProfileComplete?: boolean;
  isDPPEnrolled?: boolean;
  isTREnrolled?: boolean;
  showBachelorsWarning?: boolean;
}

const ProfileCompletionContext = createContext<ProfileCompletionContextInterface>({
  isProfileComplete: false,
  showBachelorsWarning: false,
  isDPPEnrolled: false,
  isTREnrolled: false,
});

const ProfileCompletionProvider: React.FC = ({ children }) => {
  const {
    error,
    loading,
    isProfileComplete,
    isDPPEnrolled,
    isTREnrolled,
    showBachelorsWarning,
  } = useGetProfileCompletionUserData();

  return (
    <ProfileCompletionContext.Provider
      value={{
        error,
        loading,
        isProfileComplete,
        isDPPEnrolled,
        isTREnrolled,
        showBachelorsWarning,
      }}
    >
      {children}
    </ProfileCompletionContext.Provider>
  );
};

const useProfileCompletionContext = () => useContext(ProfileCompletionContext);

export default ProfileCompletionProvider;

export {
  useProfileCompletionContext,
  ProfileCompletionContext,
  ProfileCompletionProvider,
  ProfileCompletionContextInterface,
};
